module.exports = new __parcel__URL__("pvp_button_text.ffba04b2.png").toString();